import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'

export const getVariables = createAsyncThunk('variables/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/variables/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const saveVariable = createAsyncThunk('variable/save', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    // const config = { headers: { 'content-type': 'multipart/form-data' } }
    const { data } = await axios.put(`/api/variables/${t.id}/`, t)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const createVariable = createAsyncThunk(
  'variable/create',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/variable/create/', t)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const deleteVariable = createAsyncThunk(
  'variable/delete',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/variables/${t.id}/`)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)
